import './ModalCodigoQR.scss';
import { PropTypes, number } from 'prop-types';
import { QRCode, Button, Modal, Row, Col, Form } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import QR from 'assets/images/logo_simac_qr.png';
import code from 'assets/images/Imagen_Mensajes.svg';
// import { ReactComponent as ReportProblem } from 'assets/images/ReportProblem/report_problem.svg';

const monitoringModel = {
  folio: '',
  idMonitoreo: number,
  idEstado: number,
  codigoMonitoreo: '',
  idProcesoGeneral: number,
  descProcesoGral: '',
  idTipoEleccion: number,
  idAmbito: number,
  idTipoMonitoreo: number,
  estatus: number,
  estatusSincronizado: 1,
  tipoRegistro: 1, // porque móvil realizará el registro de hallazgos
  fechaRegistro: number,
  usuario: '',
  tipoVisita: null
};

const ModalCodigoQR = ({ visible, onClose, crearActaCierre, dataQr }) => {
  const [form] = Form.useForm();

  if (Object.keys(dataQr).length > 0) {
    monitoringModel.folio = dataQr.folio;
    monitoringModel.idMonitoreo = dataQr.idMonitoreo;
    monitoringModel.idEstado = dataQr.idEstado;
    monitoringModel.idProcesoGeneral = dataQr.idProcesoGral;
    monitoringModel.descProcesoGral = dataQr.descripcionProcesoGral;
    monitoringModel.idTipoEleccion = dataQr.idTipoEleccion;
    monitoringModel.idAmbito = dataQr.idAmbito;
    monitoringModel.idTipoMonitoreo = dataQr.idTipoMonitoreo;
    monitoringModel.estatus = dataQr.estatusMonitoreo;
    monitoringModel.fechaRegistro = dataQr.fechaRegistro;
    monitoringModel.usuario = dataQr.userName;
    monitoringModel.tipoRegistro = dataQr.tipoRegistro;
    monitoringModel.codigoMonitoreo = `${dataQr.userName}_${dataQr.fechaRegistro}_${dataQr.tipoRegistro}_${dataQr.idTipoMonitoreo}`;
  }

  const handleCancel = () => {
    onClose(false);
  };

  const handleCierre = async () => {
    crearActaCierre({ dataActaCierre: { ...dataQr } });
    handleCancel();
  };

  const renderAcccions = () => {
    if (dataQr?.idActaCierre !== undefined) {
      return (
        <div>
          <Row>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>&nbsp;</span>
              <span style={{ color: '#C6C6C6', fontSize: '20px' }}>&nbsp;</span>
            </Col>
          </Row>
          <Row>
            <Col span={9} />
            <img src={code} alt="" style={{ width: 200, height: 200 }} />
          </Row>
          <Row style={{ width: '100%' }}>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontSize: '19px' }}>El acta de cierre se guardó con éxito.</span>
            </Col>
          </Row>
          <Row>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>
                ID acta:
              </span>
              <span
                style={{ color: '#C6C6C6', fontSize: '20px' }}>{`  ${dataQr?.idActaCierre}`}</span>
            </Col>
          </Row>
          <Row>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>
                Folio de monitoreo:
              </span>
              <span style={{ color: '#C6C6C6', fontSize: '20px' }}>{`  ${dataQr?.folio}`}</span>
            </Col>
          </Row>
          <Row>
            <Col span={5} />
            <Col span={19}>
              <span style={{ fontWeight: 'bold', color: '#A4A2A2', fontSize: '20px' }}>&nbsp;</span>
              <span style={{ color: '#C6C6C6', fontSize: '20px' }}>&nbsp;</span>
            </Col>
          </Row>
        </div>
      );
    }
    return (
      <div style={{ width: '100%' }}>
        <Row
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            fontSize: '1.5rem'
          }}>
          <CheckCircleFilled className="iconchecked-fill" />
          <p>El acta de inicio se guardó con éxito.</p>
        </Row>
        <div
          id="qr-canvas"
          style={{
            marginTop: '-10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '10px'
          }}>
          <Row>
            <QRCode
              width="20%"
              value={`
              {"folio": "${monitoringModel.folio}",
                "idMonitoreo": ${monitoringModel.idMonitoreo},
                "idEstado": ${monitoringModel.idEstado},
                "codigoMonitoreo": "${monitoringModel.codigoMonitoreo}",
                "idProcesoGeneral": ${monitoringModel.idProcesoGeneral},
                "descProcesoGral": "${monitoringModel.descProcesoGral}",
                "idTipoEleccion": ${monitoringModel.idTipoEleccion},
                "idAmbito": ${monitoringModel.idAmbito},
                "idTipoMonitoreo": 1,
                "estatus": ${monitoringModel.estatus},
                "estatusSincronizado": ${monitoringModel.estatusSincronizado},
                "tipoRegistro": ${monitoringModel.tipoRegistro},
                "fechaRegistro": "${monitoringModel.fechaRegistro}",
                "usuario": "${monitoringModel.usuario}"}`}
              size={320}
              errorLevel="L"
              color="#D5157E"
              bgColor="white"
              bordered
              icon={QR}
            />
          </Row>
        </div>
        <Row
          style={{
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyItems: 'center',
            justifyContent: 'center',
            padding: '10px'
          }}>
          <Col span={24}>
            <span style={{ fontWeight: '500', color: '#A4A2A2', fontSize: '1.1rem' }}>
              ID acta:
            </span>
            <span style={{ color: '#C6C6C6', fontSize: '1.2rem' }}>{`  ${dataQr?.id}`}</span>
          </Col>
          <Col span={24}>
            <span style={{ fontWeight: '500', color: '#A4A2A2', fontSize: '1.1rem' }}>
              Folio de monitoreo:
            </span>
            <span style={{ color: '#C6C6C6', fontSize: '1.2rem' }}>{`  ${dataQr?.folio}`}</span>
          </Col>
        </Row>
        <Row>
          <Col
            span={24}
            className="msj-advertencia"
            style={{
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyItems: 'center',
              justifyContent: 'center',
              padding: '10px'
            }}>
            {/* <ReportProblem /> */}
            {/* <span style={{ marginLeft: '3px', color: '#a867ee', fontSize: '0.9rem' }}>
              Al cerrar esta ventana, la opción{' '}
              <span style={{ color: '#b7006d', fontSize: '1rem', fontWeight: '600' }}>
                Generar acta de cierre
              </span>{' '}
              solo será visible en la app móvil.
            </span> */}
          </Col>
        </Row>
        <Row
          style={{
            width: '100%',
            marginTop: '10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
          className="margenbooton">
          <Col span={12} className="margenbooton">
            <Form.Item>
              <Button htmlType="submit" text="Generar acta de cierre" onClick={handleCierre}>
                Generar acta de cierre
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <Modal footer={null} width="55%" open={visible} onCancel={handleCancel} centered>
      <Form name="form-QR" layout="vertical" form={form}>
        {renderAcccions()}
      </Form>
    </Modal>
  );
};

export default ModalCodigoQR;

ModalCodigoQR.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  crearActaCierre: PropTypes.func.isRequired,
  dataQr: PropTypes.shape({
    idActaCierre: PropTypes.number,
    id: PropTypes.number,
    folio: PropTypes.string,
    idMonitoreo: PropTypes.number,
    idEstado: PropTypes.number,
    idProcesoGral: PropTypes.number,
    descripcionProcesoGral: PropTypes.string,
    idTipoEleccion: PropTypes.number,
    idAmbito: PropTypes.number,
    idTipoMonitoreo: PropTypes.number,
    estatusMonitoreo: PropTypes.number,
    fechaRegistro: PropTypes.string,
    userName: PropTypes.string,
    tipoRegistro: PropTypes.number
  }).isRequired
};
